










































import Vue from "vue";
import VelloIcon from "@/components/vue-components/VelloIcon.vue";
import vIcon from "@/components/v-components/v-icon.vue";
import { mapGetters } from "vuex";
import { Fetch } from "../plugins/fetch";

export default Vue.extend({
  name: "Unsubscribe",
  components: { vIcon, VelloIcon },
  data: () => {
    return {
      status: "base" as string
    };
  },
  computed: {
    ...mapGetters(["GET_CSRF_INFORMATION"])
  },
  created() {
    const customerId = this.$route.query.customer_id;
    const hash = this.$route.query.hash;
    const token = this.$route.query.token;
    if (customerId && hash && token) {
      this.status = "loading";
      Fetch.post(
        `customer/${customerId}/unsubscribe?hash=${hash}&token=${token}`,
        this.GET_CSRF_INFORMATION.token
      )
        .then(result => {
          if (result) {
            this.status = "success";
          }
        })
        .catch(() => {
          this.status = "fail";
        });
    } else {
      this.status = "missing-params";
    }
  }
});
